import React, { useState, useEffect } from 'react';
import Classes from './Information.module.css';
import PersonalInfo from './Comp/PersonalInfo';
import Addresses from './Comp/Addresses';
import Contact from './Comp/Contact';
import Identification from './Comp/Identification';
import Authorization from './Comp/Authorization';
import WelcomeInfoPopup from '../../../../GlobalComponents/WelcomeInfoPopup/WelcomeInfoPopup';
import { AnimatePresence } from 'framer-motion';
import SecureInfoPopup from '../../../../GlobalComponents/SecureInfoPopup/SecureInfoPopup';
import { useSelector } from 'react-redux';
import backend from '../../../../../api';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import InfoSuccessPopup from '../../../../GlobalComponents/InfoSuccessPopup/InfoSuccessPopup';
import { useNavigate } from 'react-router-dom';
import { setUserData } from '../../../../../redux-store/auth/actions';
import { useDispatch } from 'react-redux';

const ProfileIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 448 512">
    <path d="M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304l-91.4 0z" />
  </svg>
);

const LocationIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 384 512">
    <path d="M384 192c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192z" />
  </svg>
);

const EmailIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 512 512">
    <path d="M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48L48 64zM0 176L0 384c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-208L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z" />
  </svg>
);

const IdentificationIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 576 512">
    <path d="M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm80 256l64 0c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16L80 384c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm-32-96a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm256-32l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z" />
  </svg>
);

const AuthorizationIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 512 512">
    <path d="M256 0c4.6 0 9.2 1 13.4 2.9L457.7 82.8c22 9.3 38.4 31 38.3 57.2c-.5 99.2-41.3 280.7-213.6 363.2c-16.7 8-36.1 8-52.8 0C57.3 420.7 16.5 239.2 16 140c-.1-26.2 16.3-47.9 38.3-57.2L242.7 2.9C246.8 1 251.4 0 256 0z" />
  </svg>
);


export default function Information() {
  const [activePage, setActivePage] = useState(1);
  const { user } = useSelector((state) => state.auth);
  const userId = user?._id;
  const dispatch = useDispatch();


  // Initialize formData with default values
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    phoneNumber: '',
    email: '',
    dateOfBirth: '',
    gender: '',
    alternativeNames: [],
    addresses: [{ addressLine1: '', addressLine2: '', city: '', state: '', zipcode: '', country: '' }],
    contactEmail: user?.email,
    identificationUrl: '',
    authorizationSignature: '',
    userId: userId,
  });

  // Check if formData has meaningful data
  const hasFormData = () => {
    return (
      formData.firstName || formData.lastName ||
      formData.email ||
      formData.phoneNumber ||
      formData.addresses.some(
        (addr) => addr.addressLine1 || addr.city || addr.state || addr.zipcode || addr.country
      ) ||
      formData.identificationUrl ||
      formData.authorizationSignature
    );
  };

  // Load formData from localStorage on mount
  useEffect(() => {
    try {
      const savedData = localStorage.getItem('privacyBotFormData');
      if (savedData) {
        const parsedData = JSON.parse(savedData);
        // Ensure userId is current
        setFormData({ ...parsedData, userId, contactEmail: user?.email});
      }
    } catch (err) {
      console.error('Error reading from localStorage:', err);
    }
  }, [userId]);

  // Save formData to localStorage whenever it changes
  useEffect(() => {
    try {
      localStorage.setItem('privacyBotFormData', JSON.stringify(formData));
    } catch (err) {
      console.error('Error writing to localStorage:', err);
    }
  }, [formData]);

  const closePopup = localStorage.getItem('closePopup')

  // Initialize popups based on formData
  const [WelcomePopup, setWelcomePopup] = useState(user?.isFirstInteraction?true:false);
  const [InfoSecurePopup, setInfoSecurePopup] = useState(false);

  

  const handleCloseWelcomePopup = async() => {
    setWelcomePopup(false);
  };

  const handleCloseInfoSecurePopup = async() => {
    setInfoSecurePopup(false);
    handleCloseOnboardingSuccessPopup();
  };

  const handleWelcomeNext = () => {
    setWelcomePopup(false);
    setInfoSecurePopup(true);
  };

  const handleNext = () => {
    if (activePage < 5) {
      setActivePage((prev) => prev + 1);
    }
  };

  const handleBack = () => {
    if (activePage > 1) {
      setActivePage((prev) => prev - 1);
    }
  };

  const navigateTo = useNavigate();

  const [infoSuccessPopup, setinfoSuccessPopup] = useState(false);
  const handleInfoSuccessPopup = () => {
    setinfoSuccessPopup(true);
    localStorage.setItem('analyzing', true);
  };
  const handleSubmitSuccessPopup = () => {
    setinfoSuccessPopup(false);
    navigateTo('/');
  };

  const handleFinish = async () => {
    try {
      await backend.post(`/user-information/`, formData);
      console.log('Finished all steps - Data saved');
      // alert('Data saved Successfully');
      handleInfoSuccessPopup();
      // Clear localStorage on successful submission
      try {
        // localStorage.removeItem('privacyBotFormData');
      } catch (err) {
        console.error('Error clearing localStorage:', err);
      }
    } catch (err) {
      console.error('Error saving data:', err);
      alert('Error saving data. Please try again.');
    }
  };

  const sideBarSteps = [
    { id: 1, label: 'Personal Information', icon: <ProfileIcon height="17px" width="17px" fill="white" /> },
    { id: 2, label: 'Addresses', icon: <LocationIcon height="17px" width="17px" fill="white" /> },
    { id: 3, label: 'Contact', icon: <EmailIcon height="17px" width="17px" fill="white" /> },
    { id: 4, label: 'Identity', icon: <UploadFileIcon height="17px" width="17px" style={{ color: 'white' }} /> },
    { id: 5, label: 'Authorization', icon: <AuthorizationIcon height="17px" width="17px" fill="white" /> },
  ];

  const renderStepComponent = () => {
    switch (activePage) {
      case 1:
        return <PersonalInfo handleNext={handleNext} formData={formData} setFormData={setFormData} />;
      case 2:
        return <Addresses handleNext={handleNext} handleBack={handleBack} formData={formData} setFormData={setFormData} />;
      case 3:
        return <Contact handleNext={handleNext} handleBack={handleBack} formData={formData} setFormData={setFormData} />;
      case 4:
        return <Identification handleNext={handleNext} handleBack={handleBack} formData={formData} setFormData={setFormData} />;
      case 5:
        return <Authorization handleFinish={handleFinish} handleBack={handleBack} formData={formData} setFormData={setFormData} />;
      default:
        return null;
    }
  };


  const handleCloseOnboardingSuccessPopup = async () => {
    setWelcomePopup(false);
    const body = {
      isFirstInteraction: false
    }
    try {
      const resp = await backend.put(`/api/user/${userId}`,body);
      if (resp?.data) {
        await dispatch(setUserData(resp?.data?.data));
      }
    } catch (error) {
      console.error('Error updating user interaction:', error);
    }
  };

    useEffect(() => {
    const handleOnboarding = async () => {
      if (user?.isFirstInteraction) {
        setTimeout(() => {
          setWelcomePopup(true);
        }, 1000);
      } else {
        setWelcomePopup(false);
      }
    };
    handleOnboarding();
  }, [user, user?.isFirstInteraction]);


  return (
    <>
      <AnimatePresence>
        {WelcomePopup && (
          <WelcomeInfoPopup closePopup={handleCloseWelcomePopup} handleSubmit={handleWelcomeNext} />
        )}
      </AnimatePresence>
      <AnimatePresence>
        {InfoSecurePopup && <SecureInfoPopup handleClose={handleCloseInfoSecurePopup} />}
      </AnimatePresence>
      <AnimatePresence>
        {infoSuccessPopup && <InfoSuccessPopup handleSubmit={handleSubmitSuccessPopup} />}
      </AnimatePresence>

      <div className={Classes.container}>
        <div className={Classes.header}>
          <div>
            <h3>Information</h3>
            <h5>
              Enter your details so your privacy bot can track and delete your personal data. See our{' '}
              <a href="https://www.google.com" target="_blank" rel="noopener noreferrer">
                privacy policy
              </a>{' '}
              and{' '}
              <a href="https://www.google.com" target="_blank" rel="noopener noreferrer">
                data security
              </a>
              .
            </h5>
          </div>
        </div>

        <div className={Classes.hero}>
          <div className={Classes.sidebar} >
            {sideBarSteps.map((step, index) => (
              <div
                key={step.id}
                className={Classes.sideElement}
                style={{ height: index === sideBarSteps.length - 1 ? 'auto' : undefined }}
              >
                <div className={Classes.flexAlign10}>
                  <div className={`${Classes.imageCon} ${activePage >= step.id ? Classes.active : ''}`}>
                    {step.icon}
                  </div>
                  <h5 className={activePage >= step.id ? Classes.activeText : ''}>{step.label}</h5>
                </div>
                {index !== sideBarSteps.length - 1 && (
                  <div className={`${Classes.hr} ${activePage >= step.id ? Classes.coloredHr : ''}`}></div>
                )}
              </div>
            ))}
          </div>

          {renderStepComponent()}
        </div>
      </div>
    </>
  );
}